import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Form, Spinner } from "react-bootstrap";
import Knob from "./Knob";
import NumericInput from "react-numeric-input";
// import SearchBox from "./SearchBox";
import useAuth from "../../../hooks/useAuth";
import * as queryString from "query-string";
import { useLocation } from "react-router-dom";
// import GoogleMapReact from "../../../components/maps/GoogleMapReact";
import CommonMap from "../../../components/maps/CommonMap";
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import FloorplanOverlay from "../../../components/maps/FloorplanOverlay";

let Streetview = forwardRef(({ img, curFloor }, ref) => {
  // const [mapInstance, setInstance] = useState();
  // const [mapApi, setApi] = useState();
  const [rotate, setRotate] = useState();
  const [opacity, setOpacity] = useState();
  const [position, setPosition] = useState();
  const [position1, setPosition1] = useState();
  const [altitude, setAltitude] = useState();
  const [loading] = useState(false);
  const location = useLocation();
  const { id } = queryString.parse(location.search);
  // const rotateRef = useRef(rotate);
  // const searchBox = useRef();
  const { user } = useAuth();

  const [selectedGeometry, setSelectedGeometry] = useState();
  const mapLibCore = useMapsLibrary("core");
  // const mapRef = useRef(null);
  // const overlayRef = useRef(null);
  // const floorplanOverlayComponentRef = useRef();

  useEffect(() => {
    setOpacity(100);
    setRotate(0);
  }, []);

  useEffect(() => {
    // console.log("%ccurFloor changed", "color: blue; background: #ffb700ff;", {
    //   curFloor,
    // });
    setOpacity(curFloor?.opacity ?? 100);
    setRotate(curFloor?.rotation ?? 0);
  }, [curFloor, curFloor?.opacity, curFloor?.rotation]);

  useEffect(() => {
    // if (id) setLoading(true);
  }, [id]);

  useImperativeHandle(ref, () => ({
    onGetPath: () => {
      let obj = onSave();
      return obj;
    },
  }));

  // useEffect(() => {
  //   // if (overlay) {
  //   //   overlay.setMap(null);
  //   //   overlay = null;
  //   // }
  //   // if (drawingManager) {
  //   //   drawingManager.setDrawingMode(null);
  //   //   drawingManager.setMap(null);
  //   //   drawingManager = null;
  //   // }
  //   // if (selectShape) {
  //   //   selectShape.setMap(null);
  //   //   selectShape = null;
  //   // }

  //   return () => {
  //     // if (overlay) {
  //     //   overlay.setMap(null);
  //     //   overlay = null;
  //     // }
  //     // if (drawingManager) {
  //     //   drawingManager.setDrawingMode(null);
  //     //   drawingManager.setMap(null);
  //     //   drawingManager = null;
  //     // }
  //     // if (selectShape) {
  //     //   selectShape.setMap(null);
  //     //   selectShape = null;
  //     // }
  //   };
  // }, []);

  // useEffect(() => {
  //   if (
  //     !img ||
  //     !mapLibCore ||
  //     !mapRef ||
  //     !mapRef.current ||
  //     !window.google ||
  //     !window.google.maps ||
  //     !curFloor
  //   )
  //     return;

  //   let overlay;

  //   if (overlayRef.current) {
  //     return;
  //   }

  //   (async () => {
  //     const { FloorplanImageOverlay } = await import(
  //       "../../../utils/FloorplanImageOverlay"
  //     );

  //     // // Create the class AFTER google.maps exists
  //     // const MyOverlay = createMyOverlayClass(window.google);

  //     // const img = document.createElement("img");
  //     // img.src = imageUrl;

  //     overlay = new FloorplanImageOverlay(
  //       // new mapLibCore.LatLng(51.5074, -0.1278),
  //       curFloor,
  //       img,
  //       // position,
  //       // position1,
  //       setPosition,
  //       setPosition1
  //     );

  //     overlay.setMap(mapRef.current.getMap());
  //     overlayRef.current = overlay;
  //   })();

  //   return () => {
  //     overlay && overlay.setMap(null); // detach + cleanup
  //     overlayRef.current = null;
  //   };
  // }, [img, mapRef.current, mapLibCore]);

  const onSave = () => {
    if (selectedGeometry) {
      let v = selectedGeometry.getPath();
      let bounds = new mapLibCore.LatLngBounds();
      let pathArray = [];
      for (let i = 0; i < v.getLength(); i++) {
        let xy = v.getAt(i);
        let filter = pathArray.filter((item) => {
          let spit = item.split(",");
          return (
            spit[0] === xy.lng().toString() && spit[1] === xy.lat().toString()
          );
        });
        if (filter.length === 0) {
          pathArray.push(xy.lng() + "," + xy.lat());
          bounds.extend(new mapLibCore.LatLng(xy.lat(), xy.lng()));
        }
      }
      let end = pathArray[0].split(",");
      bounds.extend(new mapLibCore.LatLng(end[1], end[0]));
      return {
        position,
        position1,
        altitude,
        rotate,
        pathArray,
      };
    }
    return {
      position,
      position1,
      altitude,
      rotate,
    };
  };

  // useEffect(() => {
  //   if (!mapRef.current) return;
  //   onCenterChanged && onCenterChanged(mapRef.current.getCenter());
  //   mapRef.current.addListener("center_changed", () => {
  //     onCenterChanged && onCenterChanged(mapRef.current.getCenter());
  //   });
  // }, [mapRef.current]);

  // const apiHasLoaded = (map, maps) => {
  //   if (!map || !maps) return;
  //   if (mapInstance && mapApi) return;
  //   onCenterChanged && onCenterChanged(map.getCenter());
  //   window.myMap = map;
  //   map.addListener("center_changed", () => {
  //     onCenterChanged && onCenterChanged(map.getCenter());
  //   });
  //   setInstance(map);
  //   setApi(maps);
  // };

  // const changeOverlayPosition = (positionName, coordinateName, value) => {
  //   floorplanOverlayComponentRef.current.changeOverlayPosition(
  //     positionName,
  //     coordinateName,
  //     value
  //   );

  // let overlay = overlayRef.current;
  // if (overlay && overlay.getProjection()) {
  //   if (overlay && mapLibCore && positionName === "position") {
  //     if (coordinateName === "lat") {
  //       overlay[positionName] = new mapLibCore.LatLng(
  //         Number(value),
  //         overlay[positionName].lng()
  //       );
  //     } else if (coordinateName === "lng") {
  //       overlay[positionName] = new mapLibCore.LatLng(
  //         overlay[positionName].lat(),
  //         Number(value)
  //       );
  //     }
  //     let pos = overlay
  //       .getProjection()
  //       .fromLatLngToDivPixel(overlay.position);
  //     let x = pos.x + overlay.div.clientWidth;
  //     let y = pos.y + overlay.div.clientHeight;
  //     let bottom = overlay.getProjection().fromDivPixelToLatLng({ x, y });
  //     overlay.position1 = bottom;
  //     // overlay.draw();
  //   } else if (overlay && mapLibCore && positionName === "position1") {
  //     if (coordinateName === "lat") {
  //       overlay[positionName] = new mapLibCore.LatLng(
  //         Number(value),
  //         overlay[positionName].lng()
  //       );
  //     } else if (coordinateName === "lng") {
  //       overlay[positionName] = new mapLibCore.LatLng(
  //         overlay[positionName].lat(),
  //         Number(value)
  //       );
  //     }
  //     let pos = overlay
  //       .getProjection()
  //       .fromLatLngToDivPixel(overlay.position1);
  //     let x = pos.x - overlay.div.clientWidth;
  //     let y = pos.y - overlay.div.clientHeight;
  //     let top = overlay.getProjection().fromDivPixelToLatLng({ x, y });
  //     overlay.position = top;
  //     // overlay.draw();
  //   }
  // }
  // };

  // const initDrawPolygon = () => {
  //   if (drawingManager) {
  //     drawingManager.setDrawingMode(null);
  //     drawingManager.setMap(null);
  //     drawingManager = null;
  //   }
  //   let polyOptions = {
  //     strokeWeight: 2,
  //     fillOpacity: 0,
  //     editable: true,
  //     draggable: true,
  //   };
  //   drawingManager =
  //     mapApi.drawing.DrawingManager &&
  //     new mapApi.drawing.DrawingManager({
  //       drawingModes: [
  //         mapApi.drawing.OverlayType.POLYGON,
  //         mapApi.drawing.OverlayType.RECTANGLE,
  //       ],
  //       drawingControlOptions: {
  //         position: mapApi.ControlPosition.TOP_CENTER,
  //         drawingModes: [mapApi.drawing.OverlayType.POLYGON],
  //       },
  //       polylineOptions: {
  //         editable: true,
  //         draggable: true,
  //       },
  //       polygonOptions: polyOptions,
  //       map: mapInstance,
  //     });

  //   mapApi.event.addListener(drawingManager, "drawingmode_changed", (e) => {
  //     let mode = drawingManager.getDrawingMode();
  //     mode ? setDrawing(true) : setDrawing(false);
  //   });

  //   mapApi.event.addListener(drawingManager, "overlaycomplete", function (e) {
  //     drawingManager.setDrawingMode(null);
  //     if (e.type !== mapApi.drawing.OverlayType.MARKER) {
  //       // Switch back to non-drawing mode after drawing a shape.
  //       let newShape = e.overlay;
  //       newShape.type = e.type;
  //       selectShape && selectShape.setMap(null);
  //       selectShape = newShape;
  //       selectShape.setDraggable(false);
  //       selectShape.setEditable(false);
  //     }
  //   });
  // };

  useEffect(() => {
    if (typeof setRotate !== "function") return;
    if (curFloor?.rotation) {
      setRotate(curFloor.rotation);
    } else {
      setRotate(0);
    }
  }, [curFloor?.rotation, setRotate]);

  useEffect(() => {
    if (typeof setAltitude !== "function") return;
    if (curFloor?.altitude) {
      setAltitude(curFloor.altitude);
    } else {
      setAltitude(0);
    }
  }, [curFloor?.altitude, setAltitude]);

  useEffect(() => {
    if (!position || !position1) return;

    // console.log("streetview pos change", {
    //   position: position.toString(),
    //   position1: position1.toString(),
    // });
  }, [position, position1]);

  // useEffect(() => {
  //   if (mapApi && mapInstance && img) {
  //     setTimeout(() => addImage(), 1500);
  //   }
  //   if (mapApi && mapInstance && !img) {
  //     overlay && overlay.setMap(null);
  //     overlay = null;
  //   }
  //   if (curFloor?.rotation && mapApi && mapInstance) {
  //     setRotate(curFloor.rotation);
  //   }
  //   if (mapApi && mapInstance && curFloor?.altitude) {
  //     setAltitude(curFloor.altitude);
  //   }
  //   if (mapApi && mapInstance && !drawingManager) {
  //     initDrawPolygon();
  //   }
  //   if (mapApi && mapInstance && curFloor?.polygon) {
  //     initPolygon();
  //   }
  // }, [mapApi, mapInstance, img, curFloor]);

  return (
    <>
      <div
      // className={`floor-plan position-relative ${
      //   user?.role === "Root" ? "" : "hidden-map"
      // }`}
      // style={{ height: 450, width: "100%" }}
      >
        {/* <Form.Check
          className="position-absolute z-50 text-light"
          style={{ left: "5px" }}
          checked={drawing}
          onChange={(e) => setDrawing(e.target.checked)}
          label="Drawing boundaries"
        /> */}
        {loading && (
          <div className="w-100 z-50 bg-light position-absolute h-100 align-items-center justify-content-center d-flex">
            <Spinner animation="border" />
          </div>
        )}
        <CommonMap
          height={"450px"}
          showMapDetail={false}
          showNearByAssets={false}
          showAllLabels={false}
          showHashTagFilter={false}
          showCategoryFilter={false}
          showGoogleSearch={true}
          data={{}} // Prevents default item
        >
          <FloorplanOverlay
            mode={"edit"}
            img={img}
            curFloor={curFloor}
            opacity={opacity}
            rotate={rotate}
            selectedGeometry={selectedGeometry}
            setSelectedGeometry={setSelectedGeometry}
            setPosition={setPosition}
            setPosition1={setPosition1}
            // ref={floorplanOverlayComponentRef}
          ></FloorplanOverlay>
        </CommonMap>
        {/* <GoogleMapReact
          id={"map-google"}
          options={getMapOptions}
          bootstrapURLKeys={{
            key: globalConfig.googleMapKey,
            libraries: ["places", "geometry", "drawing", "visualization"],
          }}
          defaultCenter={{
            lat: 51.5075749806687,
            lng: Number(curFloor?.northWestLongitude) || -0.1258434166277178,
          }}
          defaultZoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
        >
          {mapInstance && mapApi && user?.role === "Root" && (
            <SearchBox ref={searchBox} map={mapInstance} mapApi={mapApi} />
          )}
        </GoogleMapReact> */}
      </div>
      <div className="d-flex align-items-center mt-4">
        <div>
          lat(north-west):{" "}
          <input
            // readOnly={user?.role !== "Root"}
            readOnly={true}
            type={"number"}
            value={(position && position.lat()) || 0}
            // onChange={(e) =>
            //   changeOverlayPosition("position", "lat", e.target.value)
            // }
            className="table-search debounceInput-search text-gray me-2"
          />
        </div>
        <div>
          lng(north-west):{" "}
          <input
            // readOnly={user?.role !== "Root"}
            readOnly={true}
            type={"number"}
            value={(position && position.lng()) || 0}
            // onChange={(e) =>
            //   changeOverlayPosition("position", "lng", e.target.value)
            // }
            className="table-search debounceInput-search text-gray me-2"
          />
        </div>
      </div>
      <div className="d-flex align-items-center mt-2">
        <div>
          lat(south-east):{" "}
          <input
            // readOnly={user?.role !== "Root"}
            readOnly={true}
            type={"number"}
            value={(position1 && position1.lat()) || 0}
            // onChange={(e) =>
            //   changeOverlayPosition("position1", "lat", e.target.value)
            // }
            className="table-search debounceInput-search text-gray me-2"
          />
        </div>
        <div>
          lng(south-east):{" "}
          <input
            // readOnly={user?.role !== "Root"}
            readOnly={true}
            type={"number"}
            value={(position1 && position1.lng()) || 0}
            // onChange={(e) =>
            //   changeOverlayPosition("position1", "lng", e.target.value)
            // }
            className="table-search debounceInput-search text-gray me-2"
          />
        </div>
      </div>
      <div className="d-flex align-items-center mt-2">
        <div>
          altitude:{" "}
          <input
            readOnly={user?.role !== "Root"}
            type={"number"}
            value={altitude || 0}
            onChange={(e) => setAltitude(Number(e.target.value))}
            className="table-search debounceInput-search text-gray me-2"
          />
        </div>
      </div>
      <div className="d-flex align-items-center mt-2">
        opacity:{" "}
        <Form.Range
          style={{ width: "100px" }}
          className="me-1 ms-1"
          value={opacity}
          onChange={(e) => setOpacity(Number(e.target.value))}
        />{" "}
        <label style={{ width: "50px" }}>{opacity} %</label>
        rotate:{" "}
        <NumericInput
          readOnly={user?.role !== "Root"}
          style={{
            input: {
              color: "#a9acb3",
            },
          }}
          className="table-search debounceInput-search"
          value={rotate}
          min={-1}
          max={360}
          onChange={(e) => setRotate(Math.min(359, Math.max(0, e % 360)))}
        />
        {user?.role === "Root" && (
          <div className="ms-2">
            <Knob
              size={60}
              degrees={360}
              min={0}
              max={359}
              value={rotate}
              color={true}
              onChange={(value) => {
                setRotate(value % 360);
              }}
            />
          </div>
        )}
      </div>
    </>
  );
});

export default Streetview;
